import React from 'react';
// components
import Divider from "@mui/material/Divider";
import { Button, Card, CardHeader, CardContent } from '@mui/material';
import Swal from 'sweetalert2';

import Page from '../../componentes/Page';
import Iconify from '../../componentes/Iconify';
import CONFIG from '../../CONFIG.json';
import { buildBody, isEmpty, workWithLocalStorage, compruebaForm } from '../../auxiliares/funciones';
import ServicioForm from './form/form';
import { getRooms } from '../../auxiliares/maestros';

// ----------------------------------------------------------------------
export default function ServicioAlta(props) {
    const usuario = workWithLocalStorage('get','usuario',null);
    const Form = {categoria:'',nombre:'',duracion:'',precio1:0,precio2:0,rooms:''}
    const obligatorios = ['categoria','nombre','duracion','precio1','rooms'];

    const [servicio, setServicio] = React.useState(Form);
    const [rooms, setRooms] = React.useState([]);
    const [cargado, setCargado] = React.useState(false);
    const [id,setId] = React.useState(props.params.id ? props.params.id : '0');

    React.useEffect(() => {
        async function cargaInicial(){
            if(!cargado){
                setRooms(await getRooms(usuario.token));

                if(id !== '0'){
                    // eslint-disable-next-line
                    const bodyJson = JSON.stringify(buildBody(usuario.token,{ id:id }))
                    fetch(`${CONFIG.api}servicio/detalle`,{
                                method: 'POST',
                                body: bodyJson,
                                headers: {'Content-Type': 'application/json'}
                        })
                        .then(res => res.json())
                        .then((result) => {
                        if (result.error === 0 && !isEmpty(result.data)) {
                            setServicio(result.data);
                        }
                        props.showLoader(false);
                        setCargado(true);
                    })
                }else{
                    props.showLoader(false);
                    setCargado(true);
                }
            }
        }
        cargaInicial();
      // eslint-disable-next-line
      },[cargado]);

    const Grabar = () =>{
        const valido = compruebaForm(Form,servicio,obligatorios);
        if(valido){
            // eslint-disable-next-line react/prop-types
            props.showLoader(true);
            const body = servicio;
            const bodyJson = JSON.stringify(buildBody(usuario.token,body))
            fetch(`${CONFIG.api}servicio/detalle`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
                let msg ='Servicio grabado!';
                if (result.error === 0) {
                    setId(result.data.id);
                    document.getElementById(`simple-tab-${props.index}`).getElementsByTagName( 'span' )[0].textContent = `Editar Servicio #${result.data.id} `;
                    setCargado(false);
                }else{
                    props.showLoader(false);
                    msg = result.errorMessage;
                }
                Swal.fire({
                title: msg,
                buttons: [{label: 'Ok'}]
                })
            })
        }else{
            Swal.fire({
                title: 'Revisa los campos con *',
                buttons: [{label: 'Ok'}]
            })
        }
    }

    const Nuevo = () =>{
        setServicio(Form);
        setId('0')
        document.getElementById(`simple-tab-${props.index}`).getElementsByTagName( 'span' )[0].textContent = 'Alta Servicio ';
    }

    const actualizaCampo = (input) =>{
        const nombre = input.target.name
        const valor = input.target.value
        servicio[nombre] = valor
        setServicio(servicio);
    }

    const Activar = () =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true);
        const body = {
          tabla: "servicios",
          activo: 1,
          id: servicio.id
        }
        const bodyJson = JSON.stringify(buildBody(usuario.token,body))
        fetch(`${CONFIG.api}master/activo`,{
                  method: 'PUT',
                  body: bodyJson,
                  headers: {'Content-Type': 'application/json'}
          })
          .then(res => res.json())
          .then((result) => {
            let msg ='Servicio activado!';
            if (result.error === 0) {
                setCargado(false);
            }else{
              props.showLoader(false);
              msg = result.errorMessage;
            }
            Swal.fire({
              title: msg,
              buttons: [{label: 'Ok'}]
            })
        })
    }

    const Borrar = () =>{
        // eslint-disable-next-line react/prop-types
        props.showLoader(true);
        const body = {
            tabla: "servicios",
            activo: 0,
            id: servicio.id
        }
        const bodyJson = JSON.stringify(buildBody(usuario.token,body))
        fetch(`${CONFIG.api}master/activo`,{
                    method: 'PUT',
                    body: bodyJson,
                    headers: {'Content-Type': 'application/json'}
            })
            .then(res => res.json())
            .then((result) => {
                let msg ='Servicio desactivado!';
                if (result.error === 0) {
                    setCargado(false);
                }else{
                    props.showLoader(false);
                    msg = result.errorMessage;
                }
                props.showLoader(false);
                Swal.fire({
                title: msg,
                buttons: [{label: 'Ok'}]
                })
        })
    }

    return (
        <Page title="Alta Servicio">
            <Card  sx={{ maxWidth: '100% !important'}}>
                <CardHeader action={<>
                                    <Button variant="contained" color="success" sx={{ color: 'white', marginRight: '15px'}} to="#" startIcon={<Iconify icon="eva:plus-fill" />}
                                    onClick={()=>Grabar(null)}>
                                        Grabar
                                    </Button>
                                    <Button variant="contained" color="primary" sx={{ color: 'white', marginRight: '15px'}} to="#" startIcon={<Iconify icon="eva:edit-outline" />}
                                    onClick={()=>Nuevo()}>
                                        Nuevo
                                    </Button>
                                    {servicio.id &&
                                    (servicio.activo === 1 ?
                                    <Button variant="contained" color="error" sx={{ color: 'white'}} to="#" startIcon={<Iconify icon="eva:trash-2-outline" />}
                                    onClick={()=>Borrar()}>
                                        Borrar
                                    </Button>
                                    : <Button variant="contained" color="warning" sx={{ color: 'white'}} to="#" startIcon={<Iconify icon="eva:refresh-fill" />}
                                    onClick={()=>Activar()}>
                                        Activar
                                    </Button>)
                                    }
                                    </>}
                        title={id === '0' ? "Alta Servicio" : `Editar Servicio #${id}`}
                />
                <Divider style={{ margin: '15px'}} />
                <CardContent>
                    {cargado &&
                    <ServicioForm showLoader={props.showLoader} rooms={rooms} servicio={servicio} actualizaCampo={actualizaCampo}/>
                    }
                </CardContent>
            </Card>
        </Page>
    );
}
